<!--表类型新增界面--> 
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" :colon="false" slot="detail" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item has-feedback :label="$t('类型代码')">
              <a-input :disabled="!!model.id" v-decorator="['mtCode', validatorRules.mtCode]" :placeholder="$t('请输入表类型代码 如 MN100')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item has-feedback :label="$t('类型名称')">
              <a-input :disabled="!!model.id" v-decorator="['mtName',validatorRules.mtName]" :placeholder="$t('请输入表类型代码简称')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('水表厂商')">
              <a-input :disabled="disabled" v-decorator="['mtCom']" :placeholder="$t('请输入水表厂商')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea :disabled="disabled" v-decorator="['remark']" rows="2" :placeholder="$t('请输入备注')"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {isUndefined} from'@/utils/validate'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MeterTypeForm',
    components: {
      JFormContainer,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterType/add",
          edit: "/jeecg-charge/meter/meterType/edit",
          queryById: "/jeecg-charge/meter/meterType/queryById",
          queryMeterTypeByUserId: "/jeecg-charge/meter/meterType/list"
        }
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          mtCode: {
            rules: [
              { required: true, message: this.$t('请输入表类型代码 如 MN100!')},
              {validator: this.validateMtCode}
            ]
          },
          mtName:{rules: [{ required: true, message: this.$t('请选择表类型名称') },
          {validator: this.validateMtName}
          ]},
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'mtCode','mtName','mtCom','remark','createTime','createBy'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'mtCode','mtName','mtCom','remark','createTime','createBy'))
      },
      // 查询类型代码是否重复
      validateMtCode(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        console.log("啦啦啦")
        let org = this.userInfo().orgCode
        let mtCode = this.form.getFieldValue('mtCode').trim();
        this.form.setFieldsValue({mtCode: mtCode});
        let params = {mtCode: mtCode,sysOrgCode: org}
        getAction(this.url.queryMeterTypeByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该类型代码已存在!"))
            }
          } else {
            callback()
          }
        })
      },
      // 查询类型代码是否重复
      validateMtName(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let mtName = this.form.getFieldValue('mtName').trim();
        this.form.setFieldsValue({mtName: mtName});
        let params = {mtName: mtName,sysOrgCode: org}
        getAction(this.url.queryMeterTypeByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该类型名称已存在!"))
            }
          } else {
            callback()
          }
        })
      },
    }
  }
</script>